<template>
    <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
        <ValidationProvider v-errors.api vid="name" tag="div" class="form-group" rules="required|max:200">
            <input v-model="form.name" v-focus type="text" class="form-control" maxlength="200" placeholder="Название автомата">
        </ValidationProvider>

        <ValidationProvider v-errors vid="serial" tag="div" class="form-group" rules="required|max:75">
            <input v-model="form.serial" type="text" class="form-control" maxlength="75" placeholder="Серийный номер">
        </ValidationProvider>

        <template v-if="hasCrt">
            <ValidationProvider v-errors vid="address" tag="div" class="form-group vm-select-address" rules="required">
                <select-vm-address id="address" v-model="form.address" :default-option="form.address" class="form-control"></select-vm-address>
            </ValidationProvider>

            <ValidationProvider v-errors vid="location" tag="div" class="center form-group mb-4" rules="required">
                <input id="location" v-model="form.location" type="text" class="form-control" placeholder="Место установки">
            </ValidationProvider>
        </template>

        <div class="d-flex justify-content-between align-items-center mb-3">
            <span>Модем</span>
            <router-link :to="{ name: 'modems' }" class="btn btn-link text-decoration-none px-0">Зарегистрировать модем</router-link>
        </div>

        <ValidationProvider v-errors.api vid="modem_id" tag="div" class="form-group">
            <SelectModem v-model="form.modem_id" :options="modems" class="form-control" />
        </ValidationProvider>

        <ValidationObserver v-if="form.modem_id && vm.id" ref="modem_sets" tag="div">
            <form-modem-settings :form="form" :sets="sets" :has-crt="hasCrt" @set="set" @form="setForm" />
        </ValidationObserver>

        <div class="my-4">
            <ValidationProvider v-errors.api vid="notify_on_state_off" tag="div" class="custom-control custom-checkbox mb-1">
                <input id="notify_on_state_off" v-model="form.notify_on_state_off" type="checkbox" class="custom-control-input">
                <label class="custom-control-label" for="notify_on_state_off">Уведомлять на почту, если кофе-машина не работает</label>
            </ValidationProvider>

            <ValidationProvider v-errors.api vid="notify_on_loading_needed" tag="div" class="custom-control custom-checkbox">
                <input id="notify_on_loading_needed" v-model="form.notify_on_loading_needed" type="checkbox" class="custom-control-input">
                <label class="custom-control-label" for="notify_on_loading_needed">Уведомлять, если закончился какой-либо ингредиент</label>
            </ValidationProvider>
        </div>

        <div class="d-flex flex-column flex-xl-row justify-content-between align-items-xl-center mb-2">
            <button :disabled="invalid || pending" class="btn btn-lg-192 btn-primary m-auto" type="submit">Сохранить</button>
        </div>
    </ValidationObserver>
</template>

<script>
import SelectModem from '@/components/SelectModem'
import FormModemSettings from '@/components/FormModemSettings'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'
import cloneDeep from 'lodash/cloneDeep'
import SelectVmAddress from './SelectVmAddress'

export default {
    components: {
        SelectVmAddress,
        SelectModem,
        FormModemSettings,
        ValidationProvider,
        ValidationObserver
    },

    props: {
        vm: {
            type: Object,
            default: _ => ({})
        },

        sets: {
            type: Object,
            default: _ => ({})
        },

        modems: {
            type: Array,
            default: _ => ([])
        },

        hasCrt: {
            type: Boolean,
            default: false
        },

        pending: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            form: cloneDeep(this.vm)
        }
    },

    computed: {
        sound: {
            get() {
                return this.sets.sound
            },
            set(value) {
                this.set({ key: 'sound', value })
            }
        }
    },

    watch: {
        vm() {
            this.form = cloneDeep(this.vm)
        }
    },

    methods: {
        set({ key, value }) {
            this.$store.dispatch('vm/set', { key, value })
        },
        setForm({ key, value }) {
            this.form[key] = value
        },

        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (isValid) {
                this.$emit('save', this.form)
            }
        },

        mixinApiErrors(errors) {
            mixinApiErrors(this.$refs.obs, errors)
        }
    }
}
</script>
